import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  Button,
  CircularProgress,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import Comment from "./meetings/Comment";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

export default function RejectComment({
  rejectConfirm,
  handleRejectConfirm,
  handleReject,
  isInitiator,
  loading,
}) {
  const [comment, setComment] = useState("");
  const { t } = useTranslation();

  return (
    <Dialog
      open={rejectConfirm}
      onClose={handleRejectConfirm}
      sx={{ justifyContent: "center" }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          padding: "24px",
          boxSizing: "border-box",
        },
      }}
    >
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={handleRejectConfirm}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>
        <Typography variant="h2" align="center" sx={{ marginBottom: "8px" }}>
          {isInitiator ? t("meeting_cancel") : t("meeting_reject")}
        </Typography>
        <Typography variant="h3" align="center" fontWeight={400}>
          {isInitiator ? t("cancel_confirm") : t("reject_confirm")}
        </Typography>
      </Box>

      <Comment comment={comment} setComment={setComment} />

      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          variant="instant"
          onClick={() => handleReject(comment)}
          style={{ marginLeft: 10, fontSize: "14px", fontWeight: "500" }}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress style={{ color: "white" }} size={20} />
          ) : (
            t("proceed")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
